module.exports = __webpack_public_path__ + "img/languages.6d561a7d.png";